import { Map as map } from 'immutable';
const C = require("../constants");

function SaleCanceledReducer(state = map(), action) {
    switch (action.type) {
        case C.SALE_CANCELED:
            return action.data;
        default:
            return state;
    }
};

export default SaleCanceledReducer;


// WEBPACK FOOTER //
// ./src/reducers/SaleCanceledReducer.js